import RecapBeautyRecommendations from 'components/Content/Recap/RecapBeautyRecommendations/RecapBeautyRecommendations';

export default RecapBeautyRecommendations;
